module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-popin-email u-fixed u-pos-tl u-zindex--51 u-fit u-flex u-flex-ai--center u-flex-jc--center",
    class: [_vm.isOpen ? 'is-open' : 'is-hidden']
  }, [_c('div', {
    staticClass: "c-popin-email__overlay u-absolute u-pos-tl u-fit u-zindex--1 u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._hidePopin()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-popin-email__wrapper u-relative u-zindex--2"
  }, [_c('div', {
    staticClass: "c-popin-email__wrapper__close-container u-absolute u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._hidePopin()
      }
    }
  }, [_c('div', {
    staticClass: "c-popin-email__wrapper__close-container__bar u-absolute u-bg--white"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-popin-email__wrapper__close-container__bar u-absolute u-bg--white"
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-color--white t-fweight--medium"
  }, [_vm._v("Ready, Set, Map")]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xxs u-color--text u-lheight--150p"
  }, [_vm._v("Stay informed and be the first to know when you can help build the new reality and earn PRAX along the way.")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_c('app-input-email', {
    staticClass: "u-marg-t-md",
    attrs: {
      "label": "Your email",
      "label-for": "email"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf66f12c"}!./src/scripts/components/app-popin-email/template.html
// module id = 482
// module chunks = 0